import { useContext } from "react";
import RestauInfo from "./RestaurantInformation/RestauInfo";
import { Box, Grid } from "@mui/material";
import { UserContext } from "src/Utils/Context/UserContext";
import { RestaurantContext } from "src/Utils/Context/RestaurantContext";
import { useNavigate, useParams } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { useGetRestaurantDetails } from "src/data/restaurant/queries/restaurant";
import { colorBackground } from "src/design/tokens";
import { NoAccess } from "src/design/NoAccess";

const HomePage = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const admin = !!user?.admin;

  const { restaurantId } = useParams();
  const { restaurants } = useContext(RestaurantContext);

  const {
    loading: detailsLoading,
    restaurantDetails,
    error: detailsError,
  } = useGetRestaurantDetails(restaurantId);

  const restaurant =
    restaurants?.find((restau) => restau.id === restaurantId) || null;

  if (!restaurantId) {
    navigate(
      restaurants[0]
        ? `/restaurant/${restaurants[0].id}`
        : "/restaurant/no-restaurant",
      { replace: true }
    );
    return null;
  }

  if (!restaurant || detailsLoading)
    return (
      <Box sx={{ display: "flex", width: "100%", justifyContent: "center", mt: 3 }}>
        <TailSpin color="#00BFFF" height={80} width={80} />
      </Box>
    );

  // The read is gated on restaurant_information_read, which staff scoped to
  // another section may not hold: say so rather than render an empty page.
  if (detailsError) return <NoAccess />;

  if (!restaurantDetails) return null;

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} style={{ maxWidth: "72rem" }} sx={{ width: "100%", px: { xs: 2, md: 4 }, py: 3 }}>
        <Box sx={{ backgroundColor: colorBackground }}>
          <RestauInfo
            restaurant={restaurant}
            restaurantDetails={restaurantDetails}
            admin={admin}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default HomePage;
